angular.module('jv.offerReject.controller', [])
    .controller('jvOfferRejectController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,jvHireBroadcastSVC) {

        $scope.state = {};

        var showNotification =  function() {
            $rootScope.$emit('showOfferRejectModalSuccess',$scope.state.dispositionEId);
            //reset the state
            $scope.state = {};
        };

        jvHireBroadcastSVC.subscribe('showOfferRejectModal', function(event, data) {
            $scope.flags.loading = false;
            $scope.state.applicationEId = data.applicationEId || data.appIds;
            $scope.state.stateEId = data.stateEId || data.stateId;
            $scope.showModals('offerRejected');
        });

        // Modal Information
        $scope.modals = {
            offerRejected: {
                show: false
            }
        };

        //Used to show the move modal
        $scope.showModals = function(modal){
            TemplateLoader.load(modal).then(function(){
                $scope.modals[modal].show = true;
            });
        };

        $scope.templates = TemplateLoader.register({
            offerRejected: '/jhire/modules/candidates/modals/offerRejected.html'
        });

        //Used to hide all the modals on the page
        $scope.hideModals = function(){
            angular.forEach($scope.modals, function(val, key) {
                 $scope.modals[key].show = false;
            });
        };

        var removeLoadingState = function(){
            $scope.flags.loading = false;
            //reset the state
            $scope.state = {};
        };

        var addLoadingState = function() {
            $scope.flags.loading = true;
        };

        $scope.offerReject = function() {
            addLoadingState();
            jvCandidatesService.offerReject($scope.state, function(response) {
                if (response && response.status === 200) {
                    showNotification();
                }else{
                    removeLoadingState();
                }
            });
            $scope.hideModals();
        };
    }
]);
